import { LoginForm } from '@/features/auth/components/LoginForm';
import { BackendStatus } from '@/components/shared/BackendStatus';
import { Logo } from '@/components/shared/Logo';

export const AdminLoginPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-accent-dark via-accent-greenDark to-accent-dark flex items-center justify-center p-4 relative">
      <BackendStatus />
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-6 [&_img]:mix-blend-normal [&_img]:brightness-110">
            <Logo size="lg" nameColor="text-primary" />
          </div>
          <h1 className="text-3xl font-bold text-primary mb-2">Admin Portal</h1>
          <p className="text-primary/80">لوحة تحكم الإدارة</p>
        </div>
        <div className="bg-primary rounded-lg shadow-xl p-8 border-2 border-accent-greenLight/30">
          <LoginForm />
        </div>
        <div className="text-center mt-6 space-y-2">
          <p className="text-primary/90 text-sm font-medium">
            حساب تجريبي — أدمن: <span className="font-mono bg-primary/30 px-2 py-1 rounded">admin@test.com</span> / <span className="font-mono bg-primary/30 px-2 py-1 rounded">Admin123</span> <span className="text-primary/60">(A كبير)</span>
          </p>
          <p className="text-primary/60 text-xs">لاعب: player1@test.com / Player123</p>
          <a href="/" className="text-primary/80 hover:text-primary text-sm block">
            ← Back to Player Portal
          </a>
        </div>
      </div>
    </div>
  );
};
